function getCropYearStatus(cropYear = {}) {
  if (cropYear.data_status === "FINALIZED") {
    return {
      label: "Finalized",
      className: "bg-green-100 text-green-800 border-green-200",
    };
  }

  const canRunAnalysis = typeof cropYear.can_run_analysis === "boolean"
    ? cropYear.can_run_analysis
    : cropYear.workflow_state === "READY";

  if (canRunAnalysis && cropYear.analysis_readiness?.eligible === false) {
    return { label: "Needs attention", className: "bg-amber-100 text-amber-900 border-amber-200" };
  }

  if (canRunAnalysis) {
    return {
      label: "Ready",
      className: "bg-sky-100 text-sky-800 border-sky-200",
    };
  }

  return {
    label: "Draft",
    className: "bg-amber-100 text-amber-900 border-amber-200",
  };
}

export default function CropYearStatusBadge({ cropYear = {} }) {
  const status = getCropYearStatus(cropYear);

  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-1 text-xs font-semibold ${status.className}`}
    >
      {status.label}
    </span>
  );
}

export { getCropYearStatus };
